import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64e1cc7d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=64e1cc7d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e1cc7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e1cc7d')) {
      api.createRecord('64e1cc7d', component.options)
    } else {
      api.reload('64e1cc7d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64e1cc7d&scoped=true", function () {
      api.rerender('64e1cc7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/integralManage/record/index.vue"
export default component.exports